<template>
  <div class="page-container">
    <div class="filter-container">
      <el-form size="small" :inline="true">
        <el-form-item :label="item.label" v-for="item in refundAllFilter" :key="item.label">
          <el-input v-model="form[item.prop]"></el-input>
        </el-form-item>
        <div class="btn-container">
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="onReset">清空</el-button>
        </div>
      </el-form>
    </div>
    <div class="table-container">
      <el-table stripe :data="tableData" size="small">
        <el-table-column :label="item.label" v-for="item in refundAllTable" :key="item.label">
          <template slot-scope="scope">
            <span v-if="item.filter">{{ item.filter(scope.row) }}</span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, slot, next, jumper"
        :current-page="pageNo"
        :page-size="pageSize"
        :page-count="pageCount"
        :total="pageTotal"
        prev-text="上一页"
        next-text="下一页"
        @current-change="onPageChange"
      >
        <span>{{ pageNo }}/{{ pageCount }}</span>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import * as R from 'ramda';
import {isAdmin} from '@/utils';
import {refund as refundApi} from '@/api';
import {mapState} from 'vuex';

export default {
  name: 'refundManage',
  data() {
    return {
      refundAllFilter: [],
      refundAllTable: [],
      form: {},
      pageSize: 15,
      pageCount: 0,
      pageNo: 1,
      pageTotal: 0,
      tableData: [],
    };
  },
  computed: {
    ...mapState('common', ['userInfo']),
    operates: ({$route}) => $route.meta.operates,
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
  },
  methods: {
    getForm() {
      const {refundAllFilter} = this.$route.meta;
      const form = {};
      R.forEach(({type, prop, start, end}) => {
        form[prop] = '';
      }, refundAllFilter);
      this.form = form;
    },
    onReset() {
      this.getForm();
    },
    onCreated() {
      const {refundAllFilter, refundAllTable} = this.$route.meta;
      this.refundAllFilter = refundAllFilter;
      this.refundAllTable = refundAllTable;
      this.getForm();
      this.query();
    },
    onSearch() {
      this.query();
    },
    onPageChange(pageNo) {
      this.query(pageNo);
    },
    async query(pageNo = 1) {
      this.pageNo = pageNo;
      const submitForm = {};
      R.forEachObjIndexed((value, key) => {
        if (!value) return;
        const filterItem = R.find(R.propEq('prop', key), this.refundAllFilter) || {};
        // if (/_/.test(key)) { // 是 datetimerange
        //   if (R.isEmpty(value)) return;
        // } else
        submitForm[key] = filterItem.dataType === 'number' ? Number(value) : String(value);
      }, this.form);
      // console.log(this.form, submitForm);
      submitForm.pageNo = this.pageNo;
      submitForm.pageSize = this.pageSize;

      const res = await refundApi.list(submitForm);
      if (res.code === 10000) {
        const {pageCount, data, total} = res;
        this.pageCount = pageCount;
        this.pageTotal = total;
        // data.forEach(e => {
        //   e.visible = false;
        // });
        this.tableData = data;
      }
    },
  },
  created() {
    this.onCreated();
    if (this.isAdmin) {
      this.canResetPassword = true;
    }
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/refund/index.vue